module.exports = __webpack_public_path__ + "static/media/number-two.f48c5cb2.svg";